import { OPEN_IMAGE_MODAL, CLOSE_IMAGE_MODAL } from "../constants/imageModal";

const openModal = data => ({
  type: OPEN_IMAGE_MODAL,
  data
});

export const openImageModal = (image, width, height) => dispatch => {
  dispatch(openModal({ image, width, height }));
};

export const closeImageModal = () => dispatch => {
  dispatch({ type: CLOSE_IMAGE_MODAL });
};



// WEBPACK FOOTER //
// ./src/actions/imageModal.js